/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const StoryCard = ({
  description, hasVideoID, image, link, linkText, videoID
}) => {
  const { alt, src } = image;
  const anchorProps = {
    href: link,
    ...(hasVideoID && { 'data-video-id': videoID })
  };

  if (link) {
    return (
      <>
        <a {...anchorProps}>
          <img className="etchStory__card__img" src={src} alt={alt} data-testid="card-link-image" />
        </a>
        <a {...anchorProps} className="etchStory__card__title">{linkText}</a>
        <p className="etchStory__card__description">{description}</p>
      </>
    );
  }
  return (
    <>
      <img className="etchStory__card__img" src={src} alt={alt} data-testid="card-link-image" />
      <p className="etchStory__card__title">{linkText}</p>
      <p className="etchStory__card__description">{description}</p>
    </>
  );
};

StoryCard.propTypes = {
  description: PropTypes.string.isRequired,
  hasVideoID: PropTypes.bool.isRequired,
  image: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string,
  }).isRequired,
  link: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired,
  linkText: PropTypes.string.isRequired,
  videoID: PropTypes.string
};

StoryCard.defaultProps = {
  videoID: ''
};

StoryCard.displayName = 'StoryCard';

export { StoryCard };
